module.exports = __webpack_public_path__ + "img/infraicon3.ea48d0ac.svg";